"use client";

import * as React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
export default function Projects() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const topics = [{
    title: "Lamine Diş (Yaprak Porselen) Nedir?",
    content: "Lamine diş; dişlerin ön yüzeyine uygulanan ince porselen kaplamalardır ve özellikle ön diş estetiğinde mükemmel sonuçlar sağlar. Kayseri’de yaprak porselen tedavisi, dişlerdeki renklenme, ayrıklık ve şekil bozukluklarını düzeltmek için sıklıkla tercih edilmektedir. Işık geçirgenliği yüksek olan bu materyaller, doğal diş görünümünü taklit ederek yapay bir görüntü oluşmasını engeller.\n\n"
  }, {
    title: "Kayseri’de Lamine Diş Nasıl Yapılır?",
    content: "Kayseri’de lamine diş tedavisi süreci, detaylı muayene ve dijital analiz ile başlar. Hastanın yüz estetiği, dudak yapısı ve diş oranları değerlendirilerek ideal gülüş tasarımı oluşturulur. Ardından diş yüzeyinde minimal düzeyde hazırlık yapılır ve kişiye özel hazırlanan porselen lamineler uygulanır. Bu süreç sayesinde hem estetik hem de fonksiyonel açıdan tatmin edici sonuçlar elde edilir.\n\n"
  }, {
    title: "Lamine Diş (Yaprak Porselen) Avantajları",
    content: "Kayseri’de lamine diş tedavisi, diş dokusunu koruyan yapısı sayesinde en çok tercih edilen estetik uygulamalardan biridir. Kısa sürede sonuç alınabilmesi, uzun ömürlü olması ve renk stabilitesinin yüksek olması en önemli avantajları arasındadır. Ayrıca doğal diş görünümüne çok yakın estetik sonuçlar sunarak hastaların özgüvenini artırır."
  }, {
    title: "Lamine Diş Kimler İçin Uygundur?",
    content: "Kayseri’de lamine diş tedavisi; dişlerinde renklenme, hafif çapraşıklık, aralık veya form bozukluğu bulunan kişiler için uygundur. Daha estetik bir gülüş isteyen ve hızlı sonuç almak isteyen hastalar için ideal bir çözümdür. Özellikle ön diş estetiğinde minimal müdahale ile maksimum sonuç hedeflenir.\n\n"
  }, {
    title: "Kayseri Lamine Diş Fiyatları",
    content: "Kayseri’de lamine diş fiyatları; uygulanacak diş sayısı ve kullanılan materyale göre değişiklik göstermektedir. En doğru fiyat bilgisi için kliniğimizde yapılacak muayene sonrası kişiye özel planlama yapılmaktadır. Kayseri’de lamine diş (yaprak porselen) yaptırmak ve estetik bir gülüşe sahip olmak için hemen bizimle iletişime geçebilirsiniz."
  }, {
    title: "Neden Bizi\xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 Seçmelisiniz?",
    content: "Kayseri'de merkezi konumdaki modern kliniğimizde, güncel teknoloji ve hasta memnuniyeti odaklı yaklaşımımızla estetik ve fonksiyonel sonuçlar sunuyoruz."
  }];
  return <section data-section-id="184775" id="kayseri-implant-tedavisi" className="relative bg-linear-to-b from-background to-secondary/20 py-20 md:py-32 lg:py-48 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        
        {/* Başlık Bölümü: text-7xl yerine responsive font eklendi ve boşluklar temizlendi */}
        <div ref={headerRef} className={`flex flex-col items-center text-center max-w-4xl mx-auto mb-16 md:mb-24 transition-all duration-1000 transform ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="font-sans text-xs md:text-sm font-semibold tracking-widest uppercase text-primary mb-4">
            Öne Çıkan Tedavilerimiz
          </span>
          <h2 className="font-serif text-foreground leading-[1.1] tracking-tight text-3xl sm:text-5xl md:text-6xl lg:text-7xl px-2">
            Kayseri Lamine Diş Tedavisi (Yaprak Porselen)
          </h2>
          <Separator className="w-24 bg-primary/40 mt-8" />
        </div>

        {/* İçerik Bölümü: !h-[1080px] kaldırıldı, h-auto (otomatik yükseklik) yapıldı */}
        <div className="transition-all duration-1000 delay-300 transform opacity-100 translate-y-0 h-auto">
          <p className="max-w-3xl mx-auto text-center font-sans text-base md:text-lg lg:text-xl text-muted-foreground leading-relaxed mb-12 md:mb-20">
            Kayseri’de lamine diş (yaprak porselen) tedavisi, estetik diş hekimliğinin en doğal ve en minimal invaziv uygulamalarından biridir. Diş Hekimi Ayşegül İnneci Uzun Kliniği olarak, dijital gülüş tasarımı teknolojileri ile dişlerinizin formunu, rengini ve dizilimini yüz hatlarınıza en uygun şekilde planlıyoruz.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10">
            {topics.map((topic, i) => <Card key={i} data-index={i} className="group bg-card/50 backdrop-blur-sm border-none shadow-sm hover:shadow-md hover:bg-secondary/30 transition-all duration-500 h-full">
                <CardHeader className="pb-4">
                  <CardTitle className="font-serif text-xl md:text-2xl lg:text-3xl text-foreground group-hover:text-primary transition-colors duration-300">
                    {topic.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="font-sans text-sm md:text-base text-muted-foreground leading-relaxed">
                    {topic.content}
                  </p>
                </CardContent>
              </Card>)}
          </div>
        </div>

      </div>
    </section>;
}